<script setup>
// NOTICE: KAPTION-INTEGRATION
// embedded-channel.DASHBOARD.4 — the platform a conversation of an Embedded
// inbox started on (web, iOS, Android), from
// conversation.additional_attributes.platform; missing means web
// (embedded-channel.API.7). Renders nothing outside Embedded inboxes.
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import {
  EMBEDDED_PLATFORMS,
  conversationPlatform,
  isEmbeddedInbox,
} from 'dashboard/helper/kaptionEmbedded';

const props = defineProps({
  conversation: { type: Object, default: () => ({}) },
});

const { t } = useI18n();
const store = useStore();

const inbox = computed(() =>
  props.conversation?.inbox_id
    ? store.getters['inboxes/getInbox'](props.conversation.inbox_id)
    : null
);

const visible = computed(() => isEmbeddedInbox(inbox.value));
const platform = computed(() => conversationPlatform(props.conversation));

const PLATFORM_UI = {
  [EMBEDDED_PLATFORMS.WEB]: {
    icon: 'i-lucide-globe',
    label: 'INBOX_MGMT.EMBEDDED.PLATFORM.WEB',
  },
  [EMBEDDED_PLATFORMS.IOS]: {
    icon: 'i-ri-apple-fill',
    label: 'INBOX_MGMT.EMBEDDED.PLATFORM.IOS',
  },
  [EMBEDDED_PLATFORMS.ANDROID]: {
    icon: 'i-ri-android-fill',
    label: 'INBOX_MGMT.EMBEDDED.PLATFORM.ANDROID',
  },
};

const ui = computed(() => PLATFORM_UI[platform.value]);
// eslint-disable-next-line @intlify/vue-i18n/no-dynamic-keys
const label = computed(() => t(ui.value.label));
</script>

<template>
  <span
    v-if="visible"
    v-tooltip="
      t('INBOX_MGMT.EMBEDDED.PLATFORM.TOOLTIP', {
        platform: label,
      })
    "
    class="inline-flex items-center flex-shrink-0 gap-1 px-1.5 py-0.5 text-xs font-medium rounded-md bg-n-alpha-2 text-n-slate-11"
    :data-platform="platform"
    data-testid="kaption-platform-chip"
  >
    <span :class="ui.icon" class="size-3" aria-hidden="true" />
    {{ label }}
  </span>
</template>
